import React from 'react';
import _ from 'lodash';

import {
  useCreditReturnAuthorizationModalQuery,
  useTriageTier1ReturnAuthorizationMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  triageWorkflowId: string;
  formState: types.IFormState;
 }

export function useQuery(returnAuthorizationId: string) {
  const tuple = useCreditReturnAuthorizationModalQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        triageWorkflowId: _.find(tuple.data?.tier1ReturnAuthorization?.group.store.triageWorkflows, wf => wf.type.name === 'credit')?.id ?? '',
        formState: {
          creditedSerialNumber: tuple.data?.tier1ReturnAuthorization?.itemReceipt?.serialNumber ?? '',
          repairCode: null
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useTriageTier1ReturnAuthorization(returnAuthorizationId: string) {
  const [fnMutate, tuple] = useTriageTier1ReturnAuthorizationMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState, triageWorkflowId: string) => {
      await fnMutate({
        variables: {
          input: {
            returnAuthorizationId,
            triageWorkflowId,
            repairCodeId: formState.repairCode?.id ?? ''
          }
        }
      });
    },
    [
      fnMutate,
      returnAuthorizationId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
